import { Button, Spinner } from "reactstrap";
import { useFileUpload } from "./hooks/useFileUpload";

const UploadSection = () => {
  const {handleFileChange, handleUpload, isLoading, isError, isSuccess} = useFileUpload();

  return (
    <div className="p-3 mb-3 border border-2 rounded" style={{backgroundColor: "#cfe2ff"}}>
      <input type="file" onChange={handleFileChange} accept=".csv,.txt"/>
      <Button onClick={handleUpload} disabled={isLoading} size="sm"> 
        Upload {isLoading && <Spinner size="sm" className="ms-1"/>}
      </Button>
      {isLoading && <p>Uploading...</p>}
      {isError && <p>Error uploading file.</p>}
      {isSuccess && <p>File uploaded successfully!</p>}
    </div>
  )
}

export default UploadSection